import React from 'react';
import './index.css';
import {auth} from '../../firebase/index.js';


class Login extends React.Component {
  constructor(props){
    super(props);
    this.state = {currentUser: null, loggedIn: false, newUser: null, newUsername: "", display: false, waiting: false};
    this.login = this.login.bind(this);
    this.changeUsername = this.changeUsername.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidMount(){
    this.props.onRef(this);
  }

  show(){
    this.setState({display: true});
  }

  hide(){
    this.setState({display: false});
  }

  changeUsername(){
    this.setState({waiting: true});
    auth.changeUsername(this.state.newUsername, function(result){
      this.setState({display: false});
      window.location.reload();
    }.bind(this));
  }

  login(provider){
    auth.signInWithPopup(provider, function(user, newUser){
      if(newUser){
        this.setState({newUser: user});
      }else{
        window.location.reload();
      }
    }.bind(this));
  }

  render(){
    return(
      <div>
        {this.state.display ? <div className="login-dialog">
            {!this.state.newUser ? <div>
              <div className="login-header">Login to save & share</div>
              <div id="login-facebook" onClick={() => {this.login(auth.facebook())}} className="login-button">Login with Facebook</div>
              <div id="login-twitter" onClick={() => {this.login(auth.twitter())}} className="login-button">Login with Twitter</div>
            </div> : <div>
              <div className="login-welcome"><div>Welcome!</div>
                <div className="login-new-profile">
                  <img className="login-new-profile-img" src={this.state.newUser.photoURL}/><span>{this.state.newUser.displayName}</span>
                </div>
              </div>
              <div className="login-header">Choose a username</div>
              <input id="login-pick-username" value={this.state.newUsername} onChange={(e) => this.setState({newUsername: e.target.value})} type="text"/>
              <div onClick={this.changeUsername} className="login-submit">{this.state.waiting ? "Creating..." : "Submit"}</div>
            </div>}
        </div> : ""}
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.js